import React from "react";

export const ErrorStep = (props) => {
  return (
    <>
      <div className="create-transfer-header">
        <h4 className="create-transfer-title"><span className="yellow">{Drupal.t("Error!")}</span></h4>
      </div>
      <div className="create-transfer-body-content">
        <div className="create-transfer-description">
          {Drupal.t("Sorry! Something went wrong.")}
        </div>
      </div>
    </>
  );
};
